import alt from '../alt';
import jpAction from '../actions/jpAction';

class jpStore {
    constructor() {
        this.bindActions(jpAction);
        this.warningMsg = "";
        this.journeyList = [];
        /*
            { _id: "12345", staffId: "A0001", userName: "Ho Kok Liang", date: new Date(), startTime: new Date(), endTime: new Date(), startLocation: "Jurong East", endLocation: "Jurong Point", googleStart: "Ho Ching Road", googleEnd: "Ho Ching Road", parking: 10.2, parkingImage:"/public/img/parkingImage.jpg" , distance: "10km", mileageClaim: 6, totalClaim: 21.4, status: 0 },
            { _id: "12315", staffId: "A0001", userName: "Ho Kok Liang", date: new Date(), startTime: new Date(), endTime: new Date(), startLocation: "Jurong East", endLocation: "Jurong Point", googleStart: "Ho Ching Road", googleEnd: "Ho Ching Road", distance: "10km", mileageClaim: 6, totalClaim: 21.4, status: 1 },
            { _id: "12325", staffId: "A0001", userName: "Ho Kok Liang", date: new Date(), startTime: new Date(), endTime: new Date(), startLocation: "Jurong East", endLocation: "Jurong Point", googleStart: "Ho Ching Road", googleEnd: "Ho Ching Road", erp: 5.20, parking: 10.2, parkingImage:"/public/img/parkingImage.jpg" , distance: "10km", mileageClaim: 6, totalClaim: 21.4, status: 1 },
            { _id: "12335", staffId: "A0001", userName: "Ho Kok Liang", date: new Date(), startTime: new Date(), endTime: new Date(), startLocation: "Jurong East", endLocation: "Jurong Point", googleStart: "Ho Ching Road", googleEnd: "Ho Ching Road", erp: 5.20, parking: 10.2, parkingImage:"/public/img/parkingImage.jpg" , distance: "10km", mileageClaim: 6, totalClaim: 21.4, status: 0 },
            { _id: "12365", staffId: "A0001", userName: "Ho Kok Liang", date: new Date(), startTime: new Date(), endTime: new Date(), startLocation: "Jurong East", endLocation: "Jurong Point", googleStart: "Ho Ching Road", googleEnd: "Ho Ching Road", erp: 5.20, parking: 10.2, parkingImage:"/public/img/parkingImage.jpg" , distance: "10km", mileageClaim: 6, totalClaim: 21.4, status: 0 },
            { _id: "12344", staffId: "A0001", userName: "Ho Kok Liang", date: new Date(), startTime: new Date(), endTime: new Date(), startLocation: "Jurong East", endLocation: "Jurong Point", googleStart: "Ho Ching Road", googleEnd: "Ho Ching Road", erp: 5.20, parking: 10.2, parkingImage:"/public/img/parkingImage.jpg" , distance: "10km", mileageClaim: 6, totalClaim: 21.4, status: 0 },
            { _id: "12341", staffId: "A0001", userName: "Ho Kok Liang", date: new Date(), startTime: new Date(), endTime: new Date(), startLocation: "Jurong East", endLocation: "Jurong Point", googleStart: "Ho Ching Road", googleEnd: "Ho Ching Road", erp: 5.20, parking: 10.2, parkingImage:"/public/img/parkingImage.jpg" , distance: "10km", mileageClaim: 6, totalClaim: 21.4, status: 0 },
        */
        this.selectedYear = new Date().getFullYear();
        this.selectedMonth = new Date().getMonth();
        this.staffId = -1;
        this.processing = false;
        this.submitRecord = [];
    }
    onWarningMsg(data) {
        this.warningMsg = data;
    }
    onProcessing(data) {
        this.processing = data;
    }

    onSelectMonth(data) {
        this.selectedYear = data.selectedYear;
        this.selectedMonth = data.selectedMonth;
    }

    onStaffId(data) {
        this.staffId = data.staffId;
    }
    onClear() {
        this.journeyList = [];
    }
    onGetJourneyPlannerSuccess(data) {
        this.journeyList = data;
    }

    onShouldListShow(data) {
        this.journeyList[data].shouldListShow = !this.journeyList[data].shouldListShow;
    }
    onCloseListShow() {
        for (let i = 0; i < this.journeyList.length; i++) {
            this.journeyList[i].shouldListShow = false;
        }
    }
    onUpdateERPSuccess(data) {
        let len = this.journeyList.length;
        for (let i = 0; i < len; i++) {
            if (this.journeyList[i]._id == data._id) {
                this.journeyList[i].erp = data.erp;
                this.journeyList[i].totalClaim = data.totalClaim;
                break;
            }
        }
    }
    updateReceiptSuccess(data) {
        let len = this.journeyList.length;
        for (let i = 0; i < len; i++) {
            if (this.journeyList[i]._id == data._id) {
                this.journeyList[i].parkingImage = data.parkingImage;
                break;
            }
        }
    }
    updateErpReceiptSuccess(data) {
        let len = this.journeyList.length;
        for (let i = 0; i < len; i++) {
            if (this.journeyList[i]._id == data._id) {
                this.journeyList[i].erpImage = data.erpImage;
                break;
            }
        }
    }
    onUpdateParkingSuccess(data) {
        let len = this.journeyList.length;
        for (let i = 0; i < len; i++) {
            if (this.journeyList[i]._id == data._id) {
                this.journeyList[i].parking = data.parking;
                this.journeyList[i].totalClaim = data.totalClaim;
                break;
            }
        }

    }
    onUpdateRemarkSuccess(data) {
        let len = this.journeyList.length;
        for (let i = 0; i < len; i++) {
            if (this.journeyList[i]._id == data._id) {
                this.journeyList[i].remark = data.remark;
                break;
            }
        }
    }
    onUpdateMileageSuccess(data) {
        let len = this.journeyList.length;
        for (let i = 0; i < len; i++) {
            if (this.journeyList[i]._id == data._id) {
                this.journeyList[i].mileageClaim = data.mileageClaim;
                this.journeyList[i].totalClaim = data.totalClaim;
                this.journeyList[i].distance = data.distance;
                this.journeyList[i].googleStart = data.googleStart;
                this.journeyList[i].googleEnd = data.googleEnd;
                break;
            }
        }

    }
    onRemoveJPSuccess(data) {
        let len = this.journeyList.length;
        let pos = -1;
        for (let i = 0; i < len; i++) {
            if (this.journeyList[i]._id == data._id) {
                pos = i;
                break;
            }
        }
        if (pos != -1) {
            this.journeyList.splice(pos, 1);
        }
    }
    onUpdateStatusSuccess(data) {
        let len = this.journeyList.length;
        for (let i = 0; i < len; i++) {
            if (this.journeyList[i]._id == data.id) {
                this.journeyList[i].status = data.status;
                break;
            }
        }
    }
    onSubmitRecord(data){
        this.submitRecord = data;
    }
    onApproveAllSuccess(data){
        if(this.staffId == data.staffId && this.selectedMonth == data.month && this.selectedYear == data.year){
            for(let i = 0 ;  i < this.journeyList.length; i++){
                if(this.journeyList[i].status == 3){
                    this.journeyList[i] = 0;
                }
            }
        }
    }
}
export default alt.createStore(jpStore, 'jpStore');


// WEBPACK FOOTER //
// ./app/stores/jpStore.js